<form [formGroup]="form" novalidate="novalidate" (ngSubmit)="submit()">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'ResetPassword' | translate }}</h4>
        <div>
            <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <div class="form-floating">
                        <input type="password" class="form-control" formControlName="NewPassword" placeholder=""
                            [ngClass]="{'is-invalid': submitted && f['NewPassword'].invalid, 'is-valid': submitted && f['NewPassword'].valid}">
                        <label class="form-label">{{ 'NewPassword' | translate }}</label>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-floating">
                    <input type="password" class="form-control m-0" formControlName="ConfirmPassword" placeholder=""
                        [ngClass]="{'is-invalid': submitted && f['ConfirmPassword'].invalid, 'is-valid': submitted && f['ConfirmPassword'].valid}">
                    <label class="form-label">{{ 'ConfirmPassword' | translate }}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">
            <i class="fe fe-x"></i>
            <span>{{ 'Cancel' | translate }}</span>
        </button>
        <button type="submit" class="btn btn-sm btn-custom"
            [disabled]="(httpService.getLoading('resetPasswordLoader'))">
            <ng-container *ngIf="(httpService.getLoading('resetPasswordLoader'))">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <span>{{ 'Saving' | translate }} ...</span>
            </ng-container>
            <ng-container *ngIf="!(httpService.getLoading('resetPasswordLoader'))">
                <i class="fe fe-check"></i>
                <span>{{ 'Save' | translate }}</span>
            </ng-container>
        </button>
    </div>
</form>